import React from "react";
export const LeftMenuContext = React.createContext();
